<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M3 21H21" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
  <path d="M5 21V5C5 3.89543 5.89543 3 7 3H17C18.1046 3 19 3.89543 19 5V21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M9 7H11" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
  <path d="M13 7H15" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
  <path d="M9 11H11" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
  <path d="M13 11H15" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
  <path d="M9 15H11" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
  <path d="M13 15H15" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
</svg>
